// extracted by mini-css-extract-plugin
export default {"Chip":"Chip_Chip__Q2mcf","noWrap":"Chip_noWrap__mYUO1","withoutBorder":"Chip_withoutBorder__XQ6HH"};